import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputSearchComponent } from './input-search.component';
import { ButtonModule } from '../../buttons/button/button.module';
import { InputTextModule } from '../input-text/input-text.module';

@NgModule({
  declarations: [InputSearchComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule
  ],
  exports: [InputSearchComponent],
})
export class InputSearchModule { }
